<div class="settings-dialog">
  <h2>Impostazioni Analisi Audio</h2>
  <div class="settings-form">
    <mat-form-field appearance="fill">
      <mat-label>Numero Interlocutori</mat-label>
      <mat-select [(ngModel)]="data.numSpeakers">
        @for (num of speakerOptions; track num) {
          <mat-option [value]="num"> {{ num }} Persone </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Lingua Audio</mat-label>
      <mat-select [(ngModel)]="data.audioLanguage">
        @for (lang of languageOptions; track lang) {
          <mat-option [value]="lang.value">
            {{ lang.label }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <mat-dialog-actions>
    <button class="button-white" mat-stroked-button (click)="onCancel()">
      Annulla
    </button>
    <button class="button-white" mat-raised-button (click)="onSave()">
      Salva
    </button>
  </mat-dialog-actions>
</div>
